// extracted by mini-css-extract-plugin
var _1 = "DocFlowSending-moduleDocFlowSending__OeK3u";
export { _1 as "DocFlowSending" }
